<template>
    <div class="fx-date">
        <div ref="calendar"></div>
    </div>
</template>

<script>
import flatpickr from 'flatpickr'

export default {
    props: {
        value: {
            required: true
        },
        mode: {
            // single, range
            type: String,
            default: 'single'
        },
        minDate: [Date, String],
        maxDate: [Date, String],
        prevMonthIcon: String,
        nextMonthIcon: String
    },
    data () {
        return {
            calendar: null
        }
    },
    watch: {
        value (range) {
            if (range) {
                this.calendar.setDate(range)
            } else {
                this.calendar.clear()
                this.calendar.jumpToDate()
            }
        }
    },
    methods: {
        initCalendar () {
            const calendarOptions = {
                mode: this.mode,
                inline: true,
                onChange: (selection) => {
                    if (this.mode !== 'range' || (this.mode === 'range' && selection.length === 2)) {
                        this.$emit('input', selection)
                    }
                }
            }
            if (this.minDate) calendarOptions.minDate = this.minDate
            if (this.maxDate) calendarOptions.maxDate = this.maxDate
            if (this.prevMonthIcon) {
                calendarOptions.prevArrow = this.prevMonthIcon
            }
            if (this.nextMonthIcon) {
                calendarOptions.nextArrow = this.nextMonthIcon
            }
            if (this.value) calendarOptions.defaultDate = this.value
            // Initialize calendar
            this.calendar = flatpickr(this.$refs.calendar, calendarOptions)
        }
    },
    mounted () {
        this.initCalendar()
    }
}
</script>

<style lang="postcss">
@import 'theme';
@import 'flatpickr/dist/flatpickr.min.css';

.flatpickr-calendar {
    box-shadow: none;
    top: 0;
    border: solid 1px var(--c-gray-8);
}

.flatpickr-month {
    margin-bottom: 4px;
}

.flatpickr-current-month {
    font-size: var(--fs-large);
    & > .cur-month {
        font-weight: var(--fw-normal) !important;
    }
    & .cur-year {
        font-weight: var(--fw-normal) !important;
    }
}

.flatpickr-next-month:hover > svg,
.flatpickr-prev-month:hover > svg {
    fill: var(--c-primary);
}

.flatpickr-weekday {
    color: var(--c-gray-4);
    font-weight: var(--fw-normal) !important;
}

.flatpickr-day {
    color: var(--c-gray-1);
    &:hover {
        border-color: var(--c-interact-hover);
        background-color: var(--c-interact-hover);
    }
    &.today {
        border-color: var(--c-gray-6);
        &:hover {
            background-color: var(--c-interact-hover) !important;
            color: var(--c-gray-1) !important;
        }
    }
    &.startRange,
    &.endRange {
        position: relative;
        border-radius: 100% !important;
        background-color: var(--c-primary);
        border-color: var(--c-primary);
        color: white !important;
        box-shadow: none !important;
    }
    &.startRange::after,
    &.endRange::before {
        content: '';
        position: absolute;
        top: -1px;
        z-index: -1;
        width: 20px;
        height: 39px;
        background-color: var(--c-primary-light);
    }
    &.startRange::after {
        right: -5px;
    }
    &.endRange::before {
        left: -5px;
    }
    &.inRange,
    &.inRange.nextMonthDay,
    &.inRange.prevMonthDay {
        background-color: var(--c-primary-light);
        border-color: var(--c-primary-light);
        box-shadow: -5px 0 0 var(--c-primary-light), 5px 0 0 var(--c-primary-light);
    }
    &.startRange.endRange {
        &::before,
        &::after {
            display: none;
        }
    }
}

.flatpickr-day.startRange + .flatpickr-day.endRange {
    box-shadow: none !important;
}
</style>
